import React, { useMemo } from 'react';
import iziToast from 'izitoast';
// import { getFileInfo } from 'src/utils';
// import { AiAgentActions, AiAgentContext } from '../pages/AgentDetailPageComponent';
import { pathImage } from './common';

interface Props {
    fileTypes: string[];
    setFilesComponent: React.Dispatch<React.SetStateAction<FileProps[]>>;
    setFiles: React.Dispatch<React.SetStateAction<File[]>>;

}

// export enum FileType {
//     URL = 'url',
//     FILE = 'file'
// }

export interface FileProps {
    key?: string;
    name: string;
    size: number;
    url?: string;
    type: string;
    // type2: FileType;
}
const pdfIcon = `${pathImage}/pdfIcon.png`;
const audioIcon = `${pathImage}/audioIcon.png`;
const wordIcon = `${pathImage}/docxIcon.png`;
const excelIcon = `${pathImage}/xlsxIcon.png`;
const csvIcon = `${pathImage}/csvIcon.png`;
const txtIcon = `${pathImage}/txtIcon.png`;
const videoIcon = `${pathImage}/videoIcon.png`;
// const youtubeIcon = `${pathImage}/youtubeIcon.png`;


export const imageFileComponent = (file: FileProps) => {
    if(file.type === 'image') {
        return (<img src={file.url} alt={file.url} width={50} height={50} className="object-cover rounded-full" />)
    } else if(file.type.includes('pdf')) {
        return (<img src={pdfIcon} alt={'pdf'} width={50} className="object-cover" />)
    } else if(file.type.includes('audio')) {
        return (<img src={audioIcon} alt={'audio'} width={50} className="object-cover" />)
    } else if(file.type.includes('wordprocess')) {
        return (<img src={wordIcon} alt={'word'} width={50} className="object-cover" />)
    } else if(file.type.includes('spreadsheet')) {
        return (<img src={excelIcon} alt={'excel'} width={50} className="object-cover" />)
    } else if(file.type.includes('csv')) {
        return (<img src={csvIcon} alt={'csv'} width={50} className="object-cover" />)
    } else if(file.type.includes('text')) {
        return (<img src={txtIcon} alt={'text'} width={50} className="object-cover" />)
    } else if(file.type.includes('video')) {
        return (<img src={videoIcon} alt={'video'} width={50} className="object-cover" />)
    }
}

export const DragAndDrop = ({ fileTypes, setFilesComponent, setFiles }: Props) => {
    const [isDragging, setIsDragging] = React.useState(false);
    const inputFileRef = React.useRef<HTMLInputElement>(null);
    // const [valueUrl, setValueUrl] = React.useState('');
    // const {state: { Agent },dispatch} = useContext(AiAgentContext);

    const accept = useMemo(() => {
        const accept2 = fileTypes.reduce((acc, val) => {
            val = val.toLowerCase();
            if(val.includes('image')) {
                acc += 'image/*,';
            } else if(val.includes('pdf')) {
                acc += '.pdf,';
            } else if(val.includes('audio')) {
                acc += 'audio/mpeg,';
            } else if(val.includes('docx')) {
                acc += 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,';
            } else if(val.includes('xlsx')) {
                acc += 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,';
            } else if(val.includes('csv')) {
                acc += '.csv,';
            } else if(val.includes('text')) {
                acc += 'text/plain,';
            } else if(val.includes('video')) {
                acc += 'video/mp4,';
            }

            return acc;
        }, "");

        return accept2.substring(0, accept2.length - 1);
    }, [fileTypes]);

    const types = useMemo(() => {
        return fileTypes.reduce((acc: string[], val) => {
            val = val.toLowerCase();
            if(val.includes('pdf')) {
                acc.push('pdf');
            } else if(val.includes('docx')) {
                acc.push('wordprocess');
            } else if(val.includes('audio')) {
                acc.push('mpeg');
            } else if(val.includes('xlsx')) {
                acc.push('spreadsheet');
            } else if(val.includes('csv')) {
                acc.push('csv');
            } else if(val.includes('text')) {
                acc.push('text');
            } else if(val.includes('video')) {
                acc.push('mp4');
            }

            return acc;
        }, []);
    }, [fileTypes]);  

    const onFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
         
        if (e.target.files?.length) {
            const files: File[] = [];
            const filesPreview: FileProps[] = [];
            const fileList = e.target.files;

            for (let i = 0; i < fileList.length; i++) {
                if(fileList[i].type.includes('image')) {
                    files.push(fileList[i]);
                    filesPreview.push({
                        name: fileList[i].name,
                        size: fileList[i].size,
                        url: URL.createObjectURL(fileList[i]),
                        type: 'image',
                        // type2: FileType.FILE
                    });
                } else {
                    files.push(fileList[i]);
                    filesPreview.push({
                        name: fileList[i].name,
                        size: fileList[i].size,
                        type: fileList[i].type,
                        // type2: FileType.FILE
                    });
                }
            }

            setFilesComponent((prevFiles) => [...prevFiles, ...filesPreview]);
            setFiles((prevFiles) => [...prevFiles, ...files]);
        }
    }

    const selectFiles = () => {
        if (inputFileRef.current) {
            inputFileRef.current.click();
        }
    };

    const onDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragging(true);
        e.dataTransfer.dropEffect = 'copy';
    };

    const onDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const onDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragging(false);
        const fileList = e.dataTransfer.files;
        const files: File[] = [];
        const filesPreview: FileProps[] = [];

        for (let i = 0; i < fileList.length; i++) {
            if (fileList[i].type.includes('image')) {
                files.push(fileList[i]);
                filesPreview.push({
                    name: fileList[i].name,
                    size: fileList[i].size,
                    url: URL.createObjectURL(fileList[i]),
                    type: 'image',
                    // type2: FileType.FILE
                });
            } else if(
                types.some(type => fileList[i].type.includes(type))
            ) {
                files.push(fileList[i]);
                filesPreview.push({
                    name: fileList[i].name,
                    size: fileList[i].size,
                    type: fileList[i].type,
                    // type2: FileType.FILE
                });
            } else {
                iziToast.warning({
                    message: "This is not a correct format file",
                    position: 'topCenter'
                });
            }
        }

        setFilesComponent((prevFiles) => [...prevFiles, ...filesPreview]);
        setFiles((prevFiles) => [...prevFiles, ...files]);
    };

    return (
        <div>
            <div
                className="border-2 border-dashed border-gray-400 w-full h-[150px] rounded-md flex justify-center items-center"
                onDragOver={onDragOver}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
            >
                {isDragging ? (
                    <p>Suelte su archivo aquí</p>
                ) : (
                    <>
                        Arrastre y suelte el archivo Aquí o
                        <span className="ml-[6px] text-gray-400" role="button" onClick={selectFiles}>
                            Navega
                        </span>
                    </>
                )}
            </div>
            {/* <div>
                <p className="text-center my-2">O</p>

                <label htmlFor="">Ingresa URL</label>
                <input
                    type="text"
                    autoComplete={'off'}
                    value={valueUrl}
                    className="py-2 px-4 w-full rounded border border-gray-400 outline-none resize-none"
                    placeholder="https://www.youtube.com"
                    onKeyDown={async(event) => {
                    if(event.key === 'Enter') {
                        event.preventDefault();
                        let file: FileProps | null;
                        if(valueUrl.includes('youtube')) {
                            file = {
                                name: valueUrl,
                                size: 10000,
                                type: 'youtube',
                                type2: FileType.URL
                            }
                            setFilesComponent((prevFiles) => [...prevFiles, file as FileProps]);
                            dispatch(AiAgentActions.setAgent({...Agent, url_video: [...Agent.url_video, valueUrl]}));
                            setValueUrl('');
                            return;
                        } else {
                            file = await getFileInfo(valueUrl);
                        }
                        
                        if(file) {
                            if(types.some(type => (file as FileProps).type.includes(type))) {
                                setFilesComponent((prevFiles) => [...prevFiles, file as FileProps]);
                                dispatch(AiAgentActions.setAgent({...Agent, url_video: [...Agent.url_video, valueUrl]}));
                                setValueUrl('');
                            } else {
                                iziToast.warning({
                                    message: "This is not a correct format file",
                                    position: 'topCenter'
                                });
                            }
                        }
                    }
                    }}
                    onChange={(event) => {
                        setValueUrl(event.target.value);
                    }}
                />
            </div> */}
            <form
                id={'form_images'}
                onReset={() => {
                    setFiles([]);
                    setFilesComponent([]);
                }}
                className="flex justify-between py-2"
            >
                <input
                    accept={accept}
                    type="file"
                    className="w-full hidden"
                    onChange={onFiles}
                    multiple
                    ref={inputFileRef}
                />
                {/* <div className="flex items-center">
                    <button
                        disabled={!imagesFile.length || loading}
                        type="submit"
                        className={BTN_CLS.concat(' mx-1 p-2 cursor-pointer disabled:opacity-10 hover:bg-zinc-700')}
                    >
                        <Icon size={1} path={loading ? mdiLoading : mdiUploadMultiple} spin={loading} />
                    </button>
                    {imagesFile.length > 0 && (
                        <button disabled={loading} type="reset" className={BTN_CLS}>
                            Reset
                        </button>
                    )}
                </div> */}
            </form>
        </div>
    );
};
